import { useLocation } from 'react-router-dom';

export const useTelasSemMenu = () => {
  const location = useLocation();
  const rotasSemMenu = ['/configuracoes', '/favoritos', '/home', '/login'];
  return rotasSemMenu.includes(location.pathname);
};
